import React, { useEffect } from "react"
import { Link } from "react-router-dom"
import { useDispatch, useSelector } from "react-redux"
import { DataGrid } from "@material-ui/data-grid"
import { DeleteOutline } from "@material-ui/icons"
// Components
import Topbar from "../../components/Topbar/Topbar"
import Sidebar from "../../components/Sidebar/Sidebar"
// Data
import { deleteShop, getShops } from "../../redux/apiCalls"
// Styles
import {
   Container,
   GridWrapper,
   Main,
   Wrapper,
   StyledLink,
   StyledButton,
   StyledIcon,
   Action,
   TitleWrapper,
   Title,
   TitleButton,
} from "./ShopList.styles"

const ShopList = () => {
   const dispatch = useDispatch()
   const shops = useSelector((state) => state.shop.shops)

   useEffect(() => {
      getShops(dispatch)
   }, [dispatch])

   const handleDelete = (id) => {
      deleteShop(id, dispatch)
   }

   const columns = [
      { field: "_id", headerName: "ID", width: 210 },
      { field: "customerCode", headerName: "Customer", width: 160 },
      { field: "name", headerName: "Name", width: 210 },
      { field: "zip", headerName: "Zip", width: 140 },
      { field: "city", headerName: "City", width: 210 },
      {
         field: "action",
         headerName: "Action",
         width: 180,
         renderCell: (params) => {
            return (
               <Action>
                  <StyledLink to={"/shop/" + params.row._id}>
                     <StyledButton>Edit</StyledButton>
                  </StyledLink>
                  <StyledIcon>
                     <DeleteOutline
                        onClick={() => handleDelete(params.row._id)}
                        color="secondary"
                     />
                  </StyledIcon>
               </Action>
            )
         },
      },
   ]

   const validShops = shops.filter((shop) => shop && shop._id)

   return (
      <>
         <Topbar />
         <Container>
            <Wrapper>
               <Sidebar />
            </Wrapper>
            <Main>
               <TitleWrapper>
                  <Title>Shops List</Title>
                  <Link to="/newShop">
                     <TitleButton>Create</TitleButton>
                  </Link>
               </TitleWrapper>
               <GridWrapper>
                  <DataGrid
                     rows={validShops}
                     columns={columns}
                     sortModel={[{ field: "zip", sort: "asc" }]}
                     initialState={{
                        sorting: {
                           sortModel: [{ field: "zip", sort: "asc" }],
                        },
                     }}
                     getRowId={(row) => row?._id}
                     disableSelectionOnClick
                     pageSize={50}
                     checkboxSelection
                     autoHeight
                  />
               </GridWrapper>
            </Main>
         </Container>
      </>
   )
}

export default ShopList
